import { socketInprogressServiceStatus } from "src/enums/socketInprogressServiceStatus";

export const SERVICE_REASON_MASK_RULES = [
    {
        patterns: ["FORGERY", "DUPLICATE FACE"],
        translationKey: "processing.defaultFailedReason",
        statuses: [socketInprogressServiceStatus.FAILED],
    },
];


export const VERIFICATION_REASON_MASK_RULES = [
    {
        patterns: ["POTENTIAL FRAUD DETECTED IN THE DOCUMENT", "DOCUMENT MAY BE ALTERED"],
        translationKey: "processing.defaultFailedReason",
    },
];

export const getMatchingMaskRule = (reason, status, rules) => {
    if (typeof reason !== "string") return null;
    const reasonUpper = reason.toUpperCase();

    return rules.find((rule) => {
        const statusMatch =
            !rule.statuses || rule.statuses.includes(status);
        const patternMatch = rule.patterns.some((pattern) =>
            reasonUpper.includes(pattern.toUpperCase())
        );
        return statusMatch && patternMatch;
    }) ?? null;
};
